import { defineComponent, ref, watch, onMounted } from "vue";
import { isMatchKeyword } from "~/extensions/utils/KeywordSearch";
export default defineComponent({
    name: "MyPageSelectBox",
    props: {
        selectList: {
            type: Array,
            default: () => []
        },
        modelValue: [Number, String, null],
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:modelValue"],
    setup: (props, { emit }) => {
        const selectElement = ref(null);
        // ローカルコピー
        const copy = ref(props.modelValue);
        // 表示用リスト（propsを正しく使う）
        const filteredOptions = ref([]);
        onMounted(() => {
            filteredOptions.value = props.selectList;
        });
        watch(() => props.modelValue, newVal => {
            copy.value = newVal;
        });
        const onUpdateValue = (value) => {
            if (value !== null || !props.isRequired) {
                emit("update:modelValue", value);
            }
        };
        // オートコンプリート
        const onFilter = (val, update) => {
            update(() => {
                filteredOptions.value = props.selectList.filter(opt => {
                    return isMatchKeyword(opt.label, val);
                });
            });
        };
        return {
            selectElement,
            copy,
            filteredOptions,
            onUpdateValue,
            onFilter
        };
    }
});
